import {
	IsNotEmpty,
	IsNumber,
	IsOptional,
	IsPositive,
	IsString,
} from 'class-validator';

export class CreateCompetitivePriceDto {
	@IsNotEmpty()
	@IsNumber()
	@IsPositive()
	public price!: number;

	@IsNotEmpty()
	@IsString()
	public vendorName!: string;

	@IsNotEmpty()
	@IsNumber()
	@IsPositive()
	public clientId!: number;
}

export class UpdateCompetitivePriceDto {
	@IsOptional()
	@IsNumber()
	@IsPositive()
	public price?: number;

	@IsOptional()
	@IsString()
	public vendorName?: string;
}

export class CompetitivePriceResponseDto {
	public _id!: number;
	public price!: number;
	public vendorName!: string;
	public fk_item__id!: number;
	public fk_client__id!: number;
	public _created_date!: Date;
	public _modified_date!: Date;
	public _creator_userId?: number | null;
	public creatorName?: string | null;
	public clientName?: string;
	public clientAddress1?: string | null;
	public clientCity?: string | null;
	public clientState?: string | null;
	public clientZip?: string | null;
	public itemDescription?: string;
	public itemExternalId?: string;
	public itemExternalId2?: string | null;
	public itemManufacturer?: string | null;
	public itemPrice?: number | null;
	public fileId?: number | null;
	public fileName?: string | null;
}
